import Vue from 'vue';
import VueRouter from 'vue-router';
import Index from '../views/index/index.vue';
import Detail from '../views/detail/index.vue';
import login from '../views/login.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'login',
        component: login
    },
    {
        path: '/index',
        name: 'index',
        component: Index
    },
    {
        path: '/detail',
        name: 'Detail',
        component: Detail
    }
];

const router = new VueRouter({
    routes
});

export default router;
